"use client";

import { useState, useEffect } from "react";
import { Sparkles, Star, Zap, Crown, Gem, Package, Hammer, Eye } from "lucide-react";
import { Button } from "@heroui/react";
import { toast } from "sonner";

const DailyLotteryPage = () => {
  // COMING SOON - Game will be available at launch
  return (
    <div className="min-h-screen bg-gradient-to-br from-[#0A0C0F] via-[#0C1113] to-[#0A0C0F] flex items-center justify-center">
      <div className="text-center">
        <div className="mb-8">
          <img 
            src="https://pulsarmoney.b-cdn.net/rhuna/icon3.png" 
            alt="Rhuna Icon" 
            className="w-24 h-24 mx-auto mb-6 animate-pulse"
          />
          <h1 className="text-6xl font-bold mb-4">
            <span className="bg-gradient-to-r from-[#60FF8A] via-emerald-500 to-cyan-500 bg-clip-text text-transparent">
              RHUNA
            </span>
            <span className="text-white"> FORGE</span>
          </h1>
          <p className="text-2xl text-[#60FF8A] font-semibold mb-2">Coming Soon</p>
          <p className="text-lg text-[#99A1AF] max-w-md mx-auto">
            The forge is being prepared for launch. Check back soon for epic crafting adventures!
          </p>
        </div>
      </div>
    </div>
  );

  // Shard types with their rarity and appearance
  // const shardTypes = {
  //   COMMON_SHARD: { 
  //     icon: Package, 
  //     color: 'text-gray-400', 
  //     bgColor: 'bg-gray-700/50', 
  //     symbol: '⬜', 
  //     name: 'Common Shard',
  //     rarity: 'Common',
  //     dropRate: 50,
  //     borderColor: '#9ca3af'
  //   },
  //   RARE_CRYSTAL: { 
  //     icon: Gem, 
  //     color: 'text-blue-400', 
  //     bgColor: 'bg-blue-900/30', 
  //     symbol: '💎', 
  //     name: 'Rare Crystal',
  //     rarity: 'Rare',
  //     dropRate: 30,
  //     borderColor: '#60a5fa'
  //   },
  //   EPIC_ESSENCE: { 
  //     icon: Star, 
  //     color: 'text-purple-400', 
  //     bgColor: 'bg-purple-900/30', 
  //     symbol: '⭐', 
  //     name: 'Epic Essence',
  //     rarity: 'Epic',
  //     dropRate: 15,
  //     borderColor: '#c084fc'
  //   },
  //   LEGENDARY_CORE: { 
  //     icon: Crown, 
  //     color: 'text-yellow-400', 
  //     bgColor: 'bg-yellow-900/30', 
  //     symbol: '👑', 
  //     name: 'Legendary Core',
  //     rarity: 'Legendary',
  //     dropRate: 5,
  //     borderColor: '#fbbf24'
  //   }
  // };

  // // Forgeable items with their recipes and rewards
  // const forgeRecipes = {
  //   INSTANT_RP_500: {
  //     name: "Shard Cache",
  //     description: "Instantly grants Rhuna Points",
  //     type: "Consumable",
  //     rarity: "Common",
  //     recipe: { COMMON_SHARD: 2 },
  //     icon: "💰",
  //     effect: "+500 RP"
  //   },
  //   INSTANT_RP_1500: {
  //     name: "Crystal Vault",
  //     description: "Instantly grants Rhuna Points", 
  //     type: "Consumable",
  //     rarity: "Rare",
  //     recipe: { COMMON_SHARD: 3, RARE_CRYSTAL: 1 },
  //     icon: "💎",
  //     effect: "+1,500 RP"
  //   },
  //   INSTANT_RP_5000: {
  //     name: "Essence Treasure",
  //     description: "Instantly grants Rhuna Points",
  //     type: "Consumable",
  //     rarity: "Epic",
  //     recipe: { RARE_CRYSTAL: 2, EPIC_ESSENCE: 1 },
  //     icon: "🏛️",
  //     effect: "+5,000 RP"
  //   },
  //   INSTANT_RP_15000: {
  //     name: "Legendary Hoard",
  //     description: "Instantly grants massive Rhuna Points",
  //     type: "Consumable",
  //     rarity: "Legendary",
  //     recipe: { EPIC_ESSENCE: 2, LEGENDARY_CORE: 1 },
  //     icon: "👑",
  //     effect: "+15,000 RP"
  //   },
  //   QUEST_MULTIPLIER: {
  //     name: "2x Quest Multiplier Badge",
  //     description: "Permanently increases all quest rewards by 100%",
  //     type: "Badge",
  //     rarity: "Epic",
  //     recipe: { RARE_CRYSTAL: 3, EPIC_ESSENCE: 2 },
  //     icon: "⚡",
  //     effect: "+100% Quest RP"
  //   },
  //   EARLY_ADOPTER_BADGE: {
  //     name: "Early Adopter Achievement",
  //     description: "Exclusive badge showing you were here from the beginning",
  //     type: "Achievement",
  //     rarity: "Legendary",
  //     recipe: { COMMON_SHARD: 5, RARE_CRYSTAL: 3, EPIC_ESSENCE: 2, LEGENDARY_CORE: 1 },
  //     icon: "🏆",
  //     effect: "Exclusive Profile Badge"
  //   }
  // };

  // const [inventory, setInventory] = useState<{
  //   COMMON_SHARD: number;
  //   RARE_CRYSTAL: number;
  //   EPIC_ESSENCE: number;
  //   LEGENDARY_CORE: number;
  // }>({
  //   COMMON_SHARD: 0,
  //   RARE_CRYSTAL: 0,
  //   EPIC_ESSENCE: 0,
  //   LEGENDARY_CORE: 0
  // });

  // const [forgedItems, setForgedItems] = useState<Array<{ id: number; key: keyof typeof forgeRecipes; name: string; description: string; recipe: Partial<{ [key in keyof typeof inventory]: number }>; icon: string; effect: string }>>([]);
  // const [isSpinning, setIsSpinning] = useState(false);
  // const [lastDrop, setLastDrop] = useState<keyof typeof inventory | null>(null);
  // const [showDrop, setShowDrop] = useState(false);
  // const [selectedRecipe, setSelectedRecipe] = useState<keyof typeof forgeRecipes | null>(null);
  // const [dailySpinsUsed, setDailySpinsUsed] = useState(0);
  // const [showForgeModal, setShowForgeModal] = useState(false);
  // const [particles, setParticles] = useState<{ id: number; x: number; y: number; delay: number }[]>([]);

  // const maxDailySpins = 3;

  // // Particle animation for forge success
  // const createParticles = () => {
  //   const newParticles = [];
  //   for (let i = 0; i < 20; i++) {
  //     newParticles.push({
  //       id: i,
  //       x: Math.random() * 100,
  //       y: Math.random() * 100,
  //       delay: Math.random() * 2,
  //     });
  //   }
  //   setParticles(newParticles);
  //   setTimeout(() => setParticles([]), 3000);
  // };

  // const spinForge = async () => {
  //   if (dailySpinsUsed >= maxDailySpins) return;

  //   setIsSpinning(true);

  //   // Simulate spinning animation
  //   await new Promise(resolve => setTimeout(resolve, 2500));

  //   // Determine drop based on rarity rates
  //   const random = Math.random() * 100;
  //   let droppedShard: keyof typeof inventory = 'COMMON_SHARD';

  //   if (random < 5) droppedShard = 'LEGENDARY_CORE';
  //   else if (random < 20) droppedShard = 'EPIC_ESSENCE';
  //   else if (random < 50) droppedShard = 'RARE_CRYSTAL';

  //   setInventory(prev => ({
  //     ...prev,
  //     [droppedShard]: prev[droppedShard] + 1
  //   }));

  //   setLastDrop(droppedShard);
  //   setDailySpinsUsed(prev => prev + 1);
  //   setIsSpinning(false);
  //   setShowDrop(true);
  //   createParticles();

  //   toast.success(`Found ${shardTypes[droppedShard].name}!`, {
  //     duration: 3000,
  //   });

  //   // Hide drop notification after 3 seconds
  //   setTimeout(() => setShowDrop(false), 3000);
  // };

  // const canForge = (recipe: Partial<{ [key in keyof typeof inventory]: number }>) => {
  //   return Object.entries(recipe).every(([shard, needed]) => 
  //     inventory[shard as keyof typeof inventory] >= needed
  //   );
  // };

  // const forgeItem = (recipeKey: keyof typeof forgeRecipes) => {
  //   const recipe = forgeRecipes[recipeKey];
  //   if (!canForge(recipe.recipe)) return;

  //   // Deduct materials
  //   const newInventory = { ...inventory };
  //   Object.entries(recipe.recipe).forEach(([shard, needed]) => {
  //     newInventory[shard as keyof typeof inventory] -= needed;
  //   });

  //   setInventory(newInventory);
  //   setForgedItems(prev => [...prev, { ...recipe, id: Date.now(), key: recipeKey }]);
  //   setShowForgeModal(false);
  //   setSelectedRecipe(null);
  //   createParticles();

  //   toast.success(`Successfully forged ${recipe.name}!`, {
  //     duration: 3000,
  //   });
  // };

  // const resetDaily = () => {
  //   setDailySpinsUsed(0);
  //   toast.success("Daily spins reset!", {
  //     duration: 2000,
  //   });
  // };

  // const ForgeModal = () => {
  //   if (!selectedRecipe) return null;
  //   const recipe = forgeRecipes[selectedRecipe];

  //   return (
  //     <div className="fixed inset-0 bg-black/70 backdrop-blur-sm flex items-center justify-center z-50">
  //       <div className="bg-[#0C1113] border border-[#1F2937] rounded-2xl p-8 max-w-md w-full mx-4">
  //         <div className="text-center mb-6">
  //           <div className="text-6xl mb-4">{recipe.icon}</div>
  //           <h3 className="text-2xl font-bold mb-2 text-white">
  //             {recipe.name}
  //           </h3>
  //           <p className="text-[#99A1AF] text-sm leading-relaxed">{recipe.description}</p>
  //           <div className={`inline-block px-3 py-1 rounded-full text-xs font-bold mt-2
  //             ${recipe.rarity === 'Legendary' ? 'bg-gradient-to-r from-yellow-400 to-orange-500' :
  //               recipe.rarity === 'Epic' ? 'bg-gradient-to-r from-purple-500 to-pink-500' :
  //               recipe.rarity === 'Rare' ? 'bg-gradient-to-r from-blue-500 to-cyan-500' :
  //               'bg-gradient-to-r from-gray-500 to-gray-600'
  //             } text-white`}>
  //             {recipe.rarity}
  //           </div>
  //         </div>

  //         <div className="mb-6">
  //           <h4 className="font-bold mb-3 text-lg text-white">Required Materials:</h4>
  //           <div className="space-y-3">
  //             {Object.entries(recipe.recipe).map(([shard, needed]) => {
  //               const shardData = shardTypes[shard as keyof typeof shardTypes];
  //               const hasEnough = inventory[shard as keyof typeof inventory] >= needed;
  //               return (
  //                 <div key={shard} className={`flex justify-between items-center p-3 rounded-lg transition-all duration-300 ${
  //                   hasEnough 
  //                     ? 'bg-[#60FF8A]/10 border border-[#60FF8A]/30' 
  //                     : 'bg-red-900/20 border border-red-500/30'
  //                 }`}>
  //                   <div className="flex items-center">
  //                     <span className="text-2xl mr-2">{shardData.symbol}</span>
  //                     <span className="font-medium text-white">{shardData.name}</span>
  //                   </div>
  //                   <div className={`font-bold ${hasEnough ? 'text-[#60FF8A]' : 'text-red-400'}`}>
  //                     {inventory[shard as keyof typeof inventory]}/{needed}
  //                   </div>
  //                 </div>
  //               );
  //             })}
  //           </div>
  //         </div>

  //         <div className="flex space-x-4">
  //           <Button
  //             onClick={() => setSelectedRecipe(null)}
  //             className="flex-1 bg-[#374151] hover:bg-[#4B5563] text-white font-medium"
  //           >
  //             Cancel
  //           </Button>
  //           <Button
  //             onClick={() => forgeItem(selectedRecipe)}
  //             disabled={!canForge(recipe.recipe)}
  //             className={`flex-1 ${
  //               canForge(recipe.recipe)
  //                 ? 'bg-[#60FF8A] text-black font-bold hover:bg-[#60FF8A]/90'
  //                 : 'bg-gray-500 cursor-not-allowed text-gray-300'
  //             }`}
  //           >
  //             {canForge(recipe.recipe) ? '⚡ Forge' : '🔒 Locked'}
  //           </Button>
  //         </div>
  //       </div>
  //     </div>
  //   );
  // };

  // return (
  //   <div className="min-h-screen bg-[#0A0C0F] text-white relative overflow-hidden">
  //     {/* Animated background elements */}
  //     <div className="absolute inset-0 opacity-10">
  //       <div className="absolute top-20 left-20 w-64 h-64 bg-gradient-to-r from-[#60FF8A] to-blue-500 rounded-full blur-3xl animate-pulse"></div>
  //       <div className="absolute bottom-20 right-20 w-96 h-96 bg-gradient-to-r from-[#60FF8A] to-purple-500 rounded-full blur-3xl animate-pulse delay-1000"></div>
  //     </div>

  //     {/* Particles */}
  //     {particles.map((particle) => (
  //       <div
  //         key={particle.id}
  //         className="absolute w-2 h-2 bg-gradient-to-r from-[#60FF8A] to-orange-500 rounded-full animate-ping"
  //         style={{
  //           left: `${particle.x}%`,
  //           top: `${particle.y}%`,
  //           animationDelay: `${particle.delay}s`,
  //         }}
  //       />
  //     ))}

  //     <div className="max-w-7xl mx-auto relative z-10 p-6">
  //       {/* Header */}
  //       <div className="text-center mb-12">
  //         <div className="flex items-center justify-center mb-6">
  //           <div className="relative">
  //             <img 
  //               src="https://pulsarmoney.b-cdn.net/rhuna/icon3.png" 
  //               alt="Rhuna Icon" 
  //               className="w-16 h-16 mr-4 animate-pulse"
  //             />
  //             <div className="absolute inset-0 bg-gradient-to-r from-[#60FF8A] to-blue-500 opacity-20 blur-xl rounded-full"></div>
  //           </div>
  //           <h1 className="text-6xl font-bold">
  //             <span className="bg-gradient-to-r from-[#60FF8A] via-emerald-500 to-cyan-500 bg-clip-text text-transparent">
  //               RHUNA
  //             </span>
  //             <span className="text-white"> FORGE</span>
  //           </h1>
  //         </div>
  //         <p className="text-xl text-[#99A1AF] max-w-2xl mx-auto leading-relaxed">
  //           Harness the power of ancient shards to forge legendary items and unlock incredible rewards
  //         </p>
  //       </div>

  //       <div className="grid grid-cols-1 xl:grid-cols-2 gap-8 mb-8">
  //         {/* Daily Forge */}
  //         <div className="bg-[#0C1113] border border-[#1F2937] rounded-2xl p-8">
  //           <h2 className="text-2xl font-bold mb-6 flex items-center text-white">
  //             <img 
  //               src="https://pulsarmoney.b-cdn.net/rhuna/icon2.png" 
  //               alt="Forge Icon" 
  //               className="w-8 h-8 mr-3"
  //             />
  //             <span className="bg-gradient-to-r from-[#60FF8A] to-emerald-500 bg-clip-text text-transparent">
  //               Daily Forge
  //             </span>
  //           </h2>

  //           {/* Forge Animation */}
  //           <div className="text-center mb-8">
  //             <div className="relative">
  //               <div className={`
  //                 w-40 h-40 mx-auto rounded-full border-4 border-dashed 
  //                 flex items-center justify-center text-7xl transition-all duration-500 relative
  //                 ${isSpinning ? 'animate-spin border-[#60FF8A] shadow-2xl shadow-[#60FF8A]/50' : 'border-[#60FF8A] shadow-xl shadow-[#60FF8A]/30'}
  //               `}>
  //                 {isSpinning ? (
  //                   <Sparkles className="text-[#60FF8A] animate-pulse w-16 h-16" />
  //                 ) : (
  //                   <div className="text-8xl animate-pulse">🔥</div>
  //                 )}
  //               </div>
  //               {isSpinning && (
  //                 <div className="absolute inset-0 rounded-full border-2 border-[#60FF8A] animate-ping"></div>
  //               )}
  //             </div>
  //             <div className="mt-6 bg-[#0A0C0F] border border-[#1F2937] rounded-lg p-4">
  //               <div className="text-lg font-bold text-[#99A1AF] mb-2">Daily Progress</div>
  //               <div className="flex justify-center space-x-2 mb-2">
  //                 {Array.from({ length: maxDailySpins }).map((_, i) => (
  //                   <div
  //                     key={i}
  //                     className={`w-4 h-4 rounded-full ${
  //                       i < dailySpinsUsed
  //                         ? 'bg-gradient-to-r from-[#60FF8A] to-emerald-500 shadow-lg shadow-[#60FF8A]/50'
  //                         : 'bg-gray-600'
  //                     }`}
  //                   />
  //                 ))}
  //               </div>
  //               <div className="text-sm text-[#99A1AF]">
  //                 {dailySpinsUsed}/{maxDailySpins} spins used
  //               </div>
  //             </div>
  //           </div>

  //           {/* Spin Button */}
  //           <div className="text-center mb-8">
  //             {dailySpinsUsed < maxDailySpins ? (
  //               <Button
  //                 onClick={spinForge}
  //                 disabled={isSpinning}
  //                 className={`
  //                   px-10 py-4 rounded-2xl font-bold text-xl transition-all duration-300 relative overflow-hidden
  //                   ${isSpinning 
  //                     ? 'bg-gray-600 cursor-not-allowed text-gray-400' 
  //                     : 'bg-gradient-to-r from-[#60FF8A] to-emerald-600 hover:from-[#60FF8A] hover:to-emerald-700 text-black transform hover:scale-105 shadow-2xl hover:shadow-[#60FF8A]/50'
  //                   }
  //                 `}
  //               >
  //                 <div className="relative z-10">
  //                   {isSpinning ? (
  //                     <div className="flex items-center">
  //                       <Sparkles className="w-6 h-6 mr-2 animate-spin" />
  //                       Forging Magic...
  //                     </div>
  //                   ) : (
  //                     <div className="flex items-center">
  //                       <Zap className="w-6 h-6 mr-2" />
  //                       Spin the Forge
  //                     </div>
  //                   )}
  //                 </div>
  //               </Button>
  //             ) : (
  //               <div className="space-y-4">
  //                 <div className="bg-gradient-to-r from-[#60FF8A]/20 to-emerald-600/20 border border-[#60FF8A]/30 text-white p-4 rounded-lg">
  //                   <div className="font-bold text-lg">⏰ Daily Limit Reached</div>
  //                   <div className="text-sm opacity-90">Come back tomorrow for more spins!</div>
  //                 </div>
  //                 <Button
  //                   onClick={resetDaily}
  //                   className="px-6 py-3 bg-gradient-to-r from-[#60FF8A] to-emerald-600 hover:from-[#60FF8A] hover:to-emerald-700 text-black rounded-lg transition-all duration-300 font-medium transform hover:scale-105"
  //                 >
  //                   🔄 Reset Day (Demo)
  //                 </Button>
  //               </div>
  //             )}
  //           </div>

  //           {/* Last Drop */}
  //           {showDrop && lastDrop && (
  //             <div className="bg-gradient-to-r from-[#60FF8A]/20 to-emerald-900/40 border-2 border-[#60FF8A] p-6 rounded-2xl mb-6 text-center animate-bounce shadow-2xl shadow-[#60FF8A]/25">
  //               <div className="text-4xl mb-2">{shardTypes[lastDrop].symbol}</div>
  //               <div className="font-bold text-xl text-[#60FF8A]">
  //                 ✨ Found {shardTypes[lastDrop].name}! ✨
  //               </div>
  //               <div className="text-sm text-[#60FF8A]/80 mt-1">Added to your inventory</div>
  //             </div>
  //           )}

  //           {/* Drop Rates */}
  //           <div className="bg-[#0A0C0F] border border-[#1F2937] p-4 rounded-lg">
  //             <div className="text-sm font-bold mb-2 text-[#99A1AF]">📊 Drop Rates</div>
  //             <div className="text-xs text-[#99A1AF] space-y-1">
  //               <div className="flex justify-between">
  //                 <span>👑 Legendary Core:</span> <span className="text-[#60FF8A]">5%</span>
  //               </div>
  //               <div className="flex justify-between">
  //                 <span>⭐ Epic Essence:</span> <span className="text-[#60FF8A]">15%</span>
  //               </div>
  //               <div className="flex justify-between">
  //                 <span>💎 Rare Crystal:</span> <span className="text-[#60FF8A]">30%</span>
  //               </div>
  //               <div className="flex justify-between">
  //                 <span>⬜ Common Shard:</span> <span className="text-[#60FF8A]">50%</span>
  //               </div>
  //             </div>
  //           </div>
  //         </div>

  //         {/* Inventory */}
  //         <div className="bg-[#0C1113] border border-[#1F2937] rounded-2xl p-8">
  //           <h2 className="text-2xl font-bold mb-6 flex items-center text-white">
  //             <img 
  //               src="https://pulsarmoney.b-cdn.net/rhuna/icon1.png" 
  //               alt="Shard Icon" 
  //               className="w-8 h-8 mr-3"
  //             />
  //             <span className="bg-gradient-to-r from-[#60FF8A] to-cyan-500 bg-clip-text text-transparent">
  //               Shard Inventory
  //             </span>
  //           </h2>
  //           <div className="grid grid-cols-2 gap-6">
  //             {Object.entries(shardTypes).map(([key, shard]) => {
  //               const Icon = shard.icon;
  //               return (
  //                 <div 
  //                   key={key} 
  //                   className={`relative p-6 rounded-2xl border-2 transition-all duration-300 hover:scale-105 group ${shard.bgColor}`}
  //                   style={{ borderColor: shard.borderColor }}
  //                 >
  //                   <div className="text-center">
  //                     <div className="text-4xl mb-3 group-hover:scale-110 transition-transform duration-300">
  //                       {shard.symbol}
  //                     </div>
  //                     <div className="font-bold text-3xl mb-2 text-white">
  //                       {inventory[key as keyof typeof inventory]}
  //                     </div>
  //                     <div className={`text-sm font-medium ${shard.color}`}>
  //                       {shard.name}
  //                     </div>
  //                     <div className="text-xs text-[#99A1AF] mt-1">
  //                       {shard.rarity}
  //                     </div>
  //                   </div>
  //                   <div 
  //                     className="absolute inset-0 rounded-2xl opacity-0 group-hover:opacity-20 transition-opacity duration-300"
  //                     style={{ backgroundColor: shard.borderColor }}
  //                   ></div>
  //                 </div>
  //               );
  //             })}
  //           </div>
  //         </div>
  //       </div>

  //       {/* Forge Recipes */}
  //       <div className="bg-[#0C1113] border border-[#1F2937] rounded-2xl p-8 mb-8">
  //         <h2 className="text-3xl font-bold mb-8 text-center text-white">
  //           <span className="bg-gradient-to-r from-orange-400 to-red-500 bg-clip-text text-transparent">
  //             🔨 Forge Recipes
  //           </span>
  //         </h2>
  //         <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6">
  //           {Object.entries(forgeRecipes).map(([key, recipe]) => {
  //             const canForgeItem = canForge(recipe.recipe);
  //             return (
  //               <div 
  //                 key={key} 
  //                 className={`
  //                   relative p-6 rounded-2xl border-2 transition-all duration-300 cursor-pointer group overflow-hidden
  //                   ${canForgeItem 
  //                     ? 'hover:scale-105 hover:shadow-2xl border-[#60FF8A] bg-gradient-to-br from-[#60FF8A]/10 to-emerald-900/20' 
  //                     : 'border-[#1F2937] bg-gradient-to-br from-gray-700/30 to-gray-800/30 hover:bg-gray-700/40'
  //                   }
  //                 `}
  //                 onClick={() => setSelectedRecipe(key as keyof typeof forgeRecipes)}
  //               >
  //                 {canForgeItem && (
  //                   <div className="absolute top-2 right-2">
  //                     <div className="w-3 h-3 bg-[#60FF8A] rounded-full animate-pulse"></div>
  //                   </div>
  //                 )}
                  
  //                 <div className="text-center mb-4">
  //                   <div className="text-5xl mb-3 group-hover:scale-110 transition-transform duration-300">
  //                     {recipe.icon}
  //                   </div>
  //                   <div className="font-bold text-lg mb-2 text-white">
  //                     {recipe.name}
  //                   </div>
  //                   <div className={`inline-block px-3 py-1 rounded-full text-xs font-bold mb-2
  //                     ${recipe.rarity === 'Legendary' ? 'bg-gradient-to-r from-yellow-400 to-orange-500' :
  //                       recipe.rarity === 'Epic' ? 'bg-gradient-to-r from-purple-500 to-pink-500' :
  //                       recipe.rarity === 'Rare' ? 'bg-gradient-to-r from-blue-500 to-cyan-500' :
  //                       'bg-gradient-to-r from-gray-500 to-gray-600'
  //                     } text-white shadow-lg`}>
  //                     {recipe.rarity}
  //                   </div>
  //                 </div>
                  
  //                 <div className="text-center mb-4">
  //                   <div className="font-bold text-[#60FF8A] text-sm">
  //                     {recipe.effect}
  //                   </div>
  //                 </div>

  //                 <div className="space-y-2">
  //                   <div className="font-bold text-sm text-[#99A1AF] mb-2">Materials Needed:</div>
  //                   {Object.entries(recipe.recipe).map(([shard, needed]) => (
  //                     <div key={shard} className="flex justify-between items-center text-xs">
  //                       <div className="flex items-center">
  //                         <span className="mr-2">{shardTypes[shard as keyof typeof shardTypes].symbol}</span>
  //                         <span className="text-white">{shardTypes[shard as keyof typeof shardTypes].name}</span>
  //                       </div>
  //                       <span className={`font-bold ${
  //                         inventory[shard as keyof typeof inventory] >= needed ? 'text-[#60FF8A]' : 'text-red-400'
  //                       }`}>
  //                         {inventory[shard as keyof typeof inventory]}/{needed}
  //                       </span>
  //                     </div>
  //                   ))}
  //                 </div>

  //                 {canForgeItem && (
  //                   <div className="absolute bottom-4 right-4">
  //                     <div className="bg-[#60FF8A] text-black px-2 py-1 rounded text-xs font-bold">
  //                       Ready!
  //                     </div>
  //                   </div>
  //                 )}
  //               </div>
  //             );
  //           })}
  //         </div>
  //       </div>

  //       {/* Forged Items */}
  //       {forgedItems.length > 0 && (
  //         <div className="bg-gradient-to-br from-[#60FF8A]/10 to-emerald-900/30 border border-[#60FF8A]/50 rounded-2xl p-8">
  //           <h2 className="text-3xl font-bold mb-8 text-center text-white">
  //             <span className="bg-gradient-to-r from-[#60FF8A] to-emerald-500 bg-clip-text text-transparent">
  //               🎉 Your Legendary Creations
  //             </span>
  //           </h2>
  //           <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6">
  //             {forgedItems.map((item, index) => (
  //               <div 
  //                 key={index} 
  //                 className="relative p-6 rounded-2xl border-2 border-[#60FF8A] bg-gradient-to-br from-[#60FF8A]/20 to-emerald-900/40 group hover:scale-105 transition-all duration-300 shadow-xl"
  //               >
  //                 <div className="text-center">
  //                   <div className="text-5xl mb-3 group-hover:scale-110 transition-transform duration-300">
  //                     {item.icon}
  //                   </div>
  //                   <div className="font-bold text-lg mb-2 text-white">
  //                     {item.name}
  //                   </div>
  //                   <div className="text-[#60FF8A] font-bold">
  //                     {item.effect}
  //                   </div>
  //                 </div>
  //                 <div className="absolute inset-0 rounded-2xl bg-gradient-to-r from-[#60FF8A]/10 to-emerald-500/10 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
  //               </div>
  //             ))}
  //           </div>
  //         </div>
  //       )}

  //       {/* Forge Modal */}
  //       {selectedRecipe && <ForgeModal />}
  //     </div>
  //   </div>
  // );
};

export default DailyLotteryPage;